import cabinetStyle from "./MentorCabinet.module.css";
import Style from "../Style.module.css";
import React, {useState} from "react";
import * as UserService from "../../api/UserService";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import EditComponent from "./EditComponent";
import {Form} from "react-bootstrap";
import CloseComponent from "./CloseComponent";
import SaveComponent from "./SaveComponent";
import MentorProfilePagePhotoUpload from "./MentorProfilePagePhotoUpload";
import PageTips from "../PageTips";
import Banner from "./Banner";
import {useTranslation} from "react-i18next";

function MentorProfilePage() {
    const [profile, setProfile] = useState("")
    const [intro, setIntro] = useState("")
    const [bio, setBio] = useState("")
    const [nickName, setNickName] = useState("")
    const [socialNetworkLink, setSocialNetworkLink] = useState("")
    const [edit, setEdit] = useState(false)
    const { t } = useTranslation('translation', { keyPrefix: 'mentorProfilePage' });

    function pullProfile() {
        UserService.fetchMentorProfile(
            handleProfile,
            () => window.alert(t('error'))
        )
    }

    function persistIntro(event) {
        setIntro(event.target.value)
    }

    function persistBio(event) {
        setBio(event.target.value)
    }

    function persistNickName(event) {
        setNickName(event.target.value)
    }

    function persistSocialNetworkLink(event) {
        setSocialNetworkLink(event.target.value)
    }

    function handleProfile(profile) {
        setProfile(profile)
        setNickName(profile.nickname)
        setIntro(profile.short_bio === null ? "" : profile.short_bio)
        setBio(profile.long_bio === null ? "" : profile.long_bio)
        setSocialNetworkLink(profile.social_url === null ? "" : profile.social_url)
    }

    function handleClose() {
        setEdit(false)
        setNickName(profile.nickname)
        setIntro(profile.short_bio === null ? "" : profile.short_bio)
        setBio(profile.long_bio === null ? "" : profile.long_bio)
        setSocialNetworkLink(profile.social_url === null ? "" : profile.social_url)
    }

    function handleSave() {
        setEdit(false)
        UserService.saveMentorProfile(nickName, intro, bio, null, socialNetworkLink, () => {
        }, () => window.alert("Failed to save"))
    }

    useEffectOnce(() => {
        pullProfile()
    }, []);

    return (
        <>
            {/*<Banner></Banner>*/}
            <div className={cabinetStyle.mainPageContainer}>
                <PageTips headerText={t('header')}>
                    <div>{t('headerText1')} <b>{t('headerText2')}<a href="/"
                                                                                                        target="_blank">LeelaOnline </a>
                    </b>
                        {t('headerText3')} <b>{t('headerText4')}</b>.
                        <br></br>
                        <br></br>
                        {t('headerText5')} <b>{t('headerText6')}</b> {t('headerText7')} <a href="/mentors"
                                                                                             target="_blank">{t('headerText8')}</a>
                        {t('headerText9')}
                        <br></br>
                        <br></br>
                        {t('headerText10')} <a href="/"
                                                          target="_blank">LeelaOnline </a>
                        {t('headerText11')} <u>{t('headerText12')}</u>
                    </div>
                </PageTips>
                <div className={cabinetStyle.profilePage}>
                    <div className={cabinetStyle.profileTopRow}>
                        <div className={Style.h5Heading}>{t('myProfile')}</div>
                        <div className={cabinetStyle.profileEditControls}>
                            {!(edit) && <EditComponent openOnClick={() => {
                                setEdit(true)
                            }} toolTipText={t('editProfile')}></EditComponent>}
                            {edit &&
                                <CloseComponent actOnClick={handleClose} toolTipText={t('cancelButton')}></CloseComponent>}
                            {edit && <SaveComponent actOnClick={handleSave} toolTipText={t('saveButton')}></SaveComponent>}
                        </div>
                    </div>
                    <div className={cabinetStyle.profileBody}>
                        <Form>
                            <Form.Group className={cabinetStyle.profileElement}>
                                <Form.Label>{t('nickName')}*</Form.Label>
                                <Form.Control
                                    readOnly={!edit}
                                    style={{
                                        backgroundColor: !edit ? '#DEE2E6' : "white",
                                        marginBottom: "24px",
                                    }}
                                    as="input"
                                    value={nickName}
                                    onChange={e => persistNickName(e)}
                                    onClick={!edit ? (e) => {
                                        setEdit(true)
                                        if ("virtualKeyboard" in navigator) {
                                            navigator.virtualKeyboard.show()
                                        }
                                    } : () => {
                                    }}
                                    aria-describedby={"nicknameHintText"}
                                />
                                <Form.Label>{t('shortBio')}*</Form.Label>
                                <Form.Control
                                    readOnly={!edit}
                                    maxLength={150}
                                    style={{
                                        backgroundColor: !edit ? '#DEE2E6' : "white",
                                        height: "100px"
                                    }}
                                    as="textarea"
                                    value={intro}
                                    onChange={e => persistIntro(e)}
                                    onClick={!edit ? () => setEdit(true) : () => {
                                    }}
                                />
                                <div></div>
                                <Form.Text
                                    style={{marginBottom: "24px"}}
                                    id="nicknameHintText"
                                    muted
                                >{t('shortBioLimit')}
                                </Form.Text>
                                <Form.Label>{t('longBio')}</Form.Label>
                                <Form.Control
                                    readOnly={!edit}
                                    style={{
                                        backgroundColor: !edit ? '#DEE2E6' : "white",
                                        height: "150px"
                                    }}
                                    as="textarea"
                                    value={bio}
                                    onChange={e => persistBio(e)}
                                    onClick={!edit ? () => setEdit(true) : () => {
                                    }}
                                >
                                </Form.Control>
                                <Form.Label style={{
                                    marginTop: "12px"
                                }}>{t('socialMediaLink')}*</Form.Label>
                                <Form.Control
                                    readOnly={!edit}
                                    style={{
                                        backgroundColor: !edit ? '#DEE2E6' : "white",
                                        marginTop: "12px",
                                        marginBottom: "12px"
                                    }}
                                    as="input"
                                    type={"url"}
                                    value={socialNetworkLink}
                                    onChange={e => persistSocialNetworkLink(e)}
                                    onClick={!edit ? () => setEdit(true) : () => {
                                    }}
                                    aria-describedby={"nicknameHintText"}
                                />

                            </Form.Group>
                        </Form>
                    </div>
                </div>
                <div className={cabinetStyle.photoTile}>
                    <div style={{
                        display: "grid",
                        gridTemplateRows: "0.1fr 1fr",
                        marginTop: "24px",
                        marginLeft: "12px",
                        width: "100%"
                    }}>
                        <div className={Style.h5Heading}>
                            {t('photo')}
                        </div>

                        <MentorProfilePagePhotoUpload profile={profile} edit={edit} pullProfile={pullProfile}/>
                    </div>
                </div>

            </div>
        </>
    )

}

export default MentorProfilePage